import template from './index-metric-health.template.html';
import controller from './index-metric-health.controller';

const indexMetricHealthComponent = {
  bindings: {
    stats: '<',
    summary: '<'
  },
  template,
  controller,
  controllerAs: 'iMHealthCtrl'
};

export default indexMetricHealthComponent;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-health/index-metric-health.component.js